<!--
 * @Author: huxiaohui 826564596@qq.com
 * @Date: 2025-06-30 15:49:20
 * @LastEditors: huxiaohui 826564596@qq.com
 * @LastEditTime: 2025-07-24 16:09:33
 * @FilePath: \client-h5\src\components\senselessPayment\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
    <div>
        <!-- <van-cell-group> -->
        <van-cell center title="钱包无感支付">
            <template #right-icon>
                <van-switch active-color="#009af3" @change="switchWalletAutoPay" v-model="isWalletAutoPay" size="24" :active-value="1" :inactive-value="0" />
            </template>
        </van-cell>
        <!-- </van-cell-group> -->
        <div class="quickPay-tip flex align-center">
            <img src="@/assets/images/pay/pay-tip.png" alt="" />
            <p class="padding">温馨提示：开启后可在充值完成且余额充足的情况下，自动为您支付当前欠缴账单，并在后续车辆离场产生新账单时为您自动支付；
                如需关闭，在【我的-余额-充值】或者【我的-个人设置】页面内关闭。</p>
        </div>

        <warning-login :show.sync="showLogin" />
    </div>
</template>

<script>
import { getWalletStatus, updateUserWalletNofeelPay, checkIsLogin } from "@/api/api";
import WarningLogin from "@/components/base/warning-login.vue";
export default {
    name: 'senselessPayment',
    components: {
        WarningLogin
    },

    data() {
        return {
            isWalletAutoPay: 0,
            showLogin: false,
        };
    },

    computed: {},

    async mounted() {
        checkIsLogin().then(async res => {
            if (res.data == 0) {
                this.showLogin = true;
                return;
            }

            else {
                await updateUserWalletNofeelPay({ status: 1 })
                await getWalletStatus().then(res => {
                    this.isWalletAutoPay = res.data
                })
            }
        }).catch(error => {
            this.showLogin = true;
        })

    },

    methods: {
        switchWalletAutoPay() {
            updateUserWalletNofeelPay({
                status: this.isWalletAutoPay,
            }).then((res) => {
                this.$toast("设置成功!");
            }).catch(error => {
                this.isWalletAutoPay = !this.isWalletAutoPay;
            });
        }
    }
}

</script>
<style lang="less" scoped>
.quickPay-tip {
    margin-top: 70px;

    img {
        width: 24px;
        height: 24px;
    }

    p {
        font-size: 26px;
        color: #616161;
        margin-left: 8px;
    }
}
</style>